export class FileUploadError extends Error {
    errCode: string;
    constructor(message: string, name: string, code: string) {
        super(message);
        this.name = name;
        this.errCode = code;
    }
}
